import { createEagerSelectActions } from '../../select/eager-select/eager-select-actions';
import { NameDirectoryPreferenceOption } from '../models/name-directory-preference-option';

export const nameDirectoryPreferenceOptionActions = createEagerSelectActions<NameDirectoryPreferenceOption>(
   '[Name Directory Preference Options]'
);
